import {
    computed,
} from 'vue'

export const TAB_CODES = {
    volunteer: 'volunteer',
    company: 'company',
}

export default function useTabsValue(props, {emit}) {
    const currentTab = computed({
        get() {
            return props.modelValue
        },
        set(val) {
            emit('update:modelValue', val)
        }
    })

    const registerTabsData = computed(() => {
        return [{
            code: TAB_CODES.volunteer,
            image: '/local/templates/main/img/icons/register-tab-volonter.svg',
            title: props.params?.messages?.volunteer || 'Волонтер'
        }, {
            code: TAB_CODES.company,
            image: '/local/templates/main/img/icons/register-tab-company.svg',
            title: props.params?.messages?.company || 'Компания'
        }]
    })

    return {
        currentTab,
        registerTabsData
    }
}